import React from 'react'

export const PaymentHistory = () => {
  return (
    <div>PaymentHistory</div>
  )
}
